/**
 * 国际化翻译约定规范：
 * en中的key要与zh的key一致，才能保证中英切换成功
 * en中value值每个单词的首字母要大写
 * example：
 * personalpwd: "Change Password", --> personalpwd: "修改密码",
 * // Change Password 每个单词的首字母大写（样例）
 * 使用方法：
 * 普通文本：$t('route.personalpwd')
 * JS使用：this.$t('route.personalpwd')
 */
export default {
  system: {
    Cold_chain_system: 'FreshMon管理平台'
  },
  // 路由
  route: {
    home: '首页',
    monitor: '监测',
    application: '应用',
    business: '资产',
    device: '设备',
    exception: '异常',
    account: '账号',
    log: '日志',
    sys: '系统',
    instance: '设备数据',
    map: '地图',
    grid: '列表数据',
    scene: '组织架构',
    organizationStructure: '组织架构',
    history: '历史数据',
    monitorTask: '检测任务',
    proberange: '监测区间',
    collectRecord: '采集数据',
    contact: '联系人',
    alarmTrigger: '报警触发',
    incubator: '保温箱',
    fridge: '冰箱',
    car: '冷藏车',
    refrigeratory: '后补式冷库',
    // sensor: '传感器',
    sensor: '温/湿度计',
    gateway: '网关',
    display: '数字显示屏',
    relay: '中继',
    base: '智能底座',
    ex: '异常记录',
    exReason: '异常原因',
    user: '用户',
    role: '角色',
    noticelog: '通知日志',
    sysLog: '系统日志',
    alarmLog: '报警开关日志',
    param: '参数',
    forwarding: '转发设置',
    resource: '访问资源',
    probeunit: '计量单位',
    customer: '企业',
    carrierType: '资产类型',
    deviceType: '探测设备类型',
    dataBoard: '数据看板',
    deviceMonitor: '设备监测',
    monitoringPoint: '资产',
    Map: '地图',
    detailData: '详细数据',
    count: '报表统计',
    download: '下载',
    workOrder: '工单',
    // 前端添加
    personalinfo: '个人档案',
    historyData: '历史记录',
    realtime: '实时数据',
    operateRecord: '操作记录',
    addShortcutbar: '添加快捷栏',
    plan: '平面图',
    alarmRecord: '报警记录',
    findCode: '查询码',
    loginCode: '登录码',
    monitorPointRealTime: '资产实时情况',
    deviceTransfer: '设备借调',
    warehouse: '仓库',
    store: '店铺',
    onlineHelp: '在线帮助设置',
    statistic: '统计',
    other: '其他',
    verificationTask: '验证任务',
    invalidRule: '无效规则',
    exportTask: '导出任务',
    overview: '总览',
    gas: '气体',
    magnetism: '门磁',
    air: '空气',
    doorMagnet:'门磁',
  },

  // 按钮标题
  buttonTitle: {
    clickSeeMore: '点击加载更多',
    LoggingIn: '登录中...',
    Details: '详情',
    SwitchOff: '关闭',
    Close_other: '关闭其他',
    Close_left: '关闭左侧',
    Close_right: '关闭右侧',
    Close_all: '关闭所有',
    Inquiresearch: '查询',
    Reset: '重置',
    Edit: '编辑',
    Delete: '删除',
    Confirm: '确认',
    Save: '保存',
    Return: '返回',
    'Next Step': '下一步',
    'Previous Step': '上一步',
    Refresh: '刷新',
    Cancel: '取消',
    Close: '关闭',
    'Add Extended Attributes': '添加',
    Submit: '提交',
    Rewrite: '重写',
    'Submit And Save Signature': '提交并保存',
    clear: '清除',
    Add: '新增',
    Add1: '新增',
  },
  // 文本
  text: {
    Shortcut_bar: '快捷栏',
    Left_menu_bar: '导航',
    Set_shortcut_bar_menu: '设置快捷栏菜单',
    language: '国际化',
    Complete: '完成',
    Day: '天',
    hour: '时',
    min: '分',
    Switching: '马不停蹄的编译中...',
    total: '总数',
    Exception_type: '异常类型',
    test: '测试',
    show: '显示标签',
    Example: '示例',
    ExampleTooltip:
      '自定义标签用于载体信息扩展，定义的标签将会在载体信息中显示',
    CustomLabel: '自定义标签',
    UserLogin: '欢迎回来',
    UserLoginSubtitle: '登录您的监测看板。',
    UserLoginChip1: '24h 实时',
    UserLoginChip2: '温湿度',
    UserLoginChip3: '设备状态',
    UserLoginChip4: '历史记录',
    CarrierType: '载体类型',
    Thermometer: '温湿度计',
    Thermograph: '温度计',
    Thermometer2: '二代温湿度计',
    Thermograph2: '二代温度计',
    'Refresh Interval (Minutes)': '刷新间隔(分)',
    Architecture: '架构',
    // Humidity1: '湿度',
    HistoricalDataLineChart: '历史数据折线图',
    Time: '时间',
    Vehicle: '车辆',
    location: '定位',
    Node_ontent: '节点内容',
    address: '地址',
    'Reason For Data Exception': '异常原因',
    Activated: '启动',
    // Details: '详情',
    'Forwarding Settings': '转发设置',
    'Add Forwarding Settings': '新增转发设置',
    Loading: '数据加载中',
    Interval: '区间',
    // total: '总记录数',
    SentSuccessfully: '发送成功',
    Search: '查询',
    Address: '地址',
    Phone: '电话',
  },

  placeholderText: {
    EnterUsername: '请输入用户名',
    EnterPassword: '请输入密码',
    EnterPasswordAgain: '请再次输入密码',
    TwoPasswordInconsistent: '两次输入密码不一致',
    EnterTimeout: '请输入超时时间',
    '6_15Char': '长度在 6 到 15 个字符',
    EnterSensorSerialNumber: '请输入传感器编号',
    SelectTimeOrDate: '请选择时间或者日期',
    TypeInYourName: '请输入姓名',
    Choose: '请选择',
    EnterYourEmail: '请输入电子邮箱',
    SelectArchitecture: '请选择架构',
    EnterUserName: '请输入用户名称',
    EnterPhoneNumber: '请输入手机号码',
    EnterContent: '请输入内容',
    ChooseStartTime: '选择开始时间',
    EnterExTime: '请输入异常延迟时间'
  },
  // 下拉选信息
  selectMsg: {
    Chinese: '中文',
    English: '英文',
    Japance: '日文',
    Logout: '退出登录',
    EditProfile: '个人档案',
    RegistrationFailed: '注册失败',
    AlarmType: '报警类型',
    Yes: '是',
    effective: '有效',
    Customize: '自定义',
    Offline: '离线',
    Online: '在线'
  },
  // 表单标题
  labelTitle: {
    label: '标签',
    display_name: '显示名称',
    password: '密码',
    // Duration: '持续时间(秒)',
    'Digital Signature': '电子签名',
    Signature: '签名',
    'Use selected signature': '使用已选签名',
    'Old Password': '旧密码',
    'New Password': '新密码',
    'Confirm Password': '确认密码',
    Name: '名称',
    Status: '状态',
    Device: '设备',
    'Internationalized Text': '国际化文本',
    Sensor: '传感器',
    current_location: '当前位置',
    'To (End Period)': '至',
    'Processing Remark': '处理备注',
    Range: '企业',
    UpdateTime: '更新时间',
    Temperature: '温度(℃)',
    Humidity: '湿度(%)',
    'Carrier Information': '载体信息',
    DeviceBinding: '设备绑定',
    'Operation History': '操作历史',
  },
  //   表格标题
  tableTitle: {
    GatewayDisabled: '网关停用',
    startingTime: '开始时间',
    endTime: '结束时间',
    Operating: '操作',
    Carrier: '载体',
    'real-time_data': '实时数据',
    historical_data: '历史数据',
    Indicator: '指标',
    'Collection Time': '收集时间',
    Range: '范围',
    Operation: '操作',
    'Creation Time': '创建时间',
    'Sensor Serial Number': '传感器编号',
    'Carrier Name': '载体名称',
    Result: '结果',
    'Method Of Reason Selection': '选择原因方式',
    Reasons: '原因',
    remark: '备注',
    'Platform Name': '平台名称',
    'Vendor Code': '平台编码',
    params: '参数',
    OperatingUser: '操作用户'
  }, // 系统设置
  // 消息提示框
  messageTitle: {
    // 'Command has been generated and ready to be issued':'不会修改配置，也不会生成发出的命令',
    SelectACarrierInTheSameRange: '请选择同一范围下的载体',
    ExitFailed: '退出失败',
    ReasonCanNotBeEmpty: '原因不能为空',
    UploadedFileCanOnlyBeInXlsx: '上传的文件只能是xlsx格式',
    DragFilesHere: '将文件拖到此处',
    ClickToUpload: '点击上传',
    Or: '或 ',
    ModifiedSuccessfully: '修改成功',
    OperatedSuccessfully: '操作成功',
    DeleteFailed: '删除失败',
    DeleteToContinue: '此操作将永久删除该信息 是否继续?',
    Yes: '确定',
    Cancel: '取消',
    NameExit: '名称已存在',
    ConfirmToLogOutOfAccount: '确定退出当前账号吗？',
    runCheckTaskNotToDel: '运行中的检测任务不能删除',
    PleaseTickAtLeastOne: '至少勾选一项',
    CannotBeEmpty: '必填项不能为空',
    SelectTheNodeUnderTheRange: '企业不可选,请选择企业下的节点',
    UsernameCannotBeEmpty: '账号不能为空',
    PasswordCannotBeEmpty: '密码不能为空',
    VerificationCodeCannotBeEmpty: '验证码不能为空',
    PleaseSelectArchit: '请选择架构',
    PleaseFillInThePassword: '请填写密码',
    IncorrectPassword: '密码不正确',
    ContentNotEmpty: '内容不能为空',
    PleaseChooseATime: '请选择时间',
    SystemException: '系统异常',
    AddressAlreadySave: '已经保存地址',
    '2_20Character': '长度在 2 到 20 个字符',
    'CharacterLengthAt4-16': '长度在 4 到 16 个字符',
    'CharacterLengthAt4-20': '长度在 4 到 50 个字符',
    CharacterLengthAt4: '长度为4个字符',
    RangeCanNotBeEmpty: '范围不能为空',
    TextFormat: '文本格式:{"zh_CN":"”张三”","en_US":"ZhangSan"}',
  },
  week: {
    Monday: '周一',
    Tuesday: '周二',
    Wednesday: '周三',
    Thursday: '周四',
    Friday: '周五',
    Saturday: '周六',
    Sunday: '周日'
  },
  // 对话框标题
  dialogTitle: {
    TableData: '表格数据',
    SelectTimeZone: '选择时区',
    EditSensorDescription: '编辑传感器描述',
    EditSensor: '编辑传感器',
    Edit: '编辑',
    AddMonitoringInterval: '新增监测区间',
    EditMonitoringInterval: '编辑监测区间',
    DetailContent: '详细内容',
    Process: '处理',
    AddDisplayScreen: '新增显示屏',
    AddGateway: '新增网关',
    AddSensor: '新增传感器',
    ManageAlarmObjects: '管理报警对象',
    SetSwitch: '设置开关',
    EditDisplayScreen: '编辑显示屏',
    Confirm: '确认',
    ImportSensor: '导入传感器',
    ImportGateway: '导入网关',
    ImportRelay: '导入中继',
    ImportDisplay: '导入显示屏',
    EditGatewayRouter: '编辑网关路由',
    AddGatewayRouter: '新增网关路由',
    Prompt: '提示',
    ShowTableColumn: '配置表格显示的列',
    ConfigTable: '配置表格',
    UnselectedColumn: '可选择显示的列',
    SelectedColumn: '已选择显示的列',
    ImportGas: '导入气体',
    ImportMagnetism: '导入门磁',
  },
  //  复选框标题
  //  校验规则
  validateRule: {
    ReasonCanNotBeEmpty: '原因方式不能为空',
    ParameterNotEmpty: '参数不能为空',
    PlatformCodeNotEmpty: '平台编码不能为空',
    PlatformNameNotEmpty: '平台名称不能为空',

    PlatformCodeNotEmpty1: '平台编码已存在',
    PlatformNameNotEmpty1: '平台名称已存在',

    ServerEmpty: '服务器名称不能为空',
    hostEmpty: 'host地址不能为空',
    postEmpty: '端口不能为空',
    clientIdEmpty: 'client_id不能为空'
  },
  //  原生表格
  //  首页设置
  /**
   * @description: 系统向导国际化
   * @param {*guideText}
   * @return {*}
   */
  guideText: {
    Complete: '完成',
    /** 传感器大小值的变化 */
    /** 后续补充 */
    Maximum_value27: '同一范围下，已存在相同的编号',
  },
  /**
   * @description: 迭代2至5期的国际化  设备管理模块
   * @param {* langText}
   * @return {*}
   */
  langText: {
    /** 传感器 */
    /** --------- */
    /** -------------- 2-5的校验 */
    /** input输入提示语 */
    /** 传感器设备日志表格 */
    StartTime_chooze: '选择开始时间',
    EndTime_chooze: '选择结束时间',
    /** 其他 */
    /** 传感器大小值的变化 */
    /** 网关路由 */
    /** 显示屏 */
    Alarm_duration: '报警持续时间',
    /** 中继 */

  },
  // 计划任务国际化
  // task: {
  //     'RemoveInterface': '移除接口调用批量数据查询状态码',
  //     'CheckSensorBreakdown': '检测传感器故障',
  //     'CheckDisplayBreakdown': '检测多功能终端故障',
  //     'CheckGatewayBreakdown': '检测网关故障',
  //     'CheckRelayBreakdown': '监测中继故障',
  // },
  /** 迭代第七版 */
}
